// extracted by mini-css-extract-plugin
export default {"button":"Button_button__nd-SI","s":"Button_s__11Meg","m":"Button_m__p0nLu","l":"Button_l__auHXL"};